import React, { ChangeEvent } from 'react';

type TFreelancerDetailsTextFieldProps = {
    handleTextFieldChange: (
        event: ChangeEvent<HTMLInputElement>,
        fieldName: string,
    ) => void;
    isEdit: boolean;
    value: string;
    apiField: string;
    fieldName: string;
    humanReadable: string;
    testId: string;
}
export default function FreelancerDetailsTextField({
    handleTextFieldChange,
    isEdit,
    value,
    apiField,
    fieldName,
    humanReadable,
    testId,
}:TFreelancerDetailsTextFieldProps) {

    return (
        <tr>
            <td className="table-default__cell--text-blue">
                {humanReadable}
            </td>
            {isEdit ? (
                <td>
                    <input
                        data-testid={testId}
                        type="text"
                        value={value}
                        onChange={event => {
                            handleTextFieldChange(event, fieldName);
                        }}
                    />
                </td>
            ) : (
                <td>
                    {apiField}
                </td>
            )}
        </tr>
    );
}
